export const notificationsKeys = {
  all: [{ module: 'notifications' }] as const,
  list: () => [{ ...notificationsKeys.all[0], scope: 'list' }] as const,
  settings: () => [{ ...notificationsKeys.all[0], scope: 'settings' }] as const,
  pushSubscriptions: () => [{ ...notificationsKeys.all[0], scope: 'pushSubscriptions' }] as const,
  jobSubscriptions: () => [{ ...notificationsKeys.all[0], scope: 'jobSubscriptions' }] as const,
  jobSubscriptionsList: () => [{ ...notificationsKeys.jobSubscriptions()[0], kind: 'list' }] as const,
  workspaceSubscriptions: () => [{ ...notificationsKeys.all[0], scope: 'workspaceSubscriptions' }] as const,
  workspaceSubscriptionsList: () => [{ ...notificationsKeys.workspaceSubscriptions()[0], kind: 'list' }] as const,
};
